<div class="mt-5">
    <p class="pathErrMsg">Registration Url is opened in another tab. Close all the tabs and try again.</p>
</div>
